import AgTable from "./ag_table";

export default AgTable;
